var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 0C7.363 0 5.07383 0.94825 3.386 2.636C1.69817 4.32383 0.75 6.613 0.75 9C0.75 11.387 1.69825 13.6762 3.386 15.364C5.07383 17.0518 7.363 18 9.75 18C12.137 18 14.4262 17.0518 16.114 15.364C17.8018 13.6762 18.75 11.387 18.75 9C18.75 7.42018 18.3341 5.86817 17.5442 4.5C16.7543 3.13183 15.6182 1.99567 14.25 1.20583C12.8819 0.415917 11.3299 3.3315e-05 9.75003 3.3315e-05L9.75 0ZM10.95 13.6C10.95 14.0287 10.7213 14.4249 10.35 14.6393C9.97872 14.8536 9.52128 14.8536 9.15 14.6393C8.77872 14.4249 8.55 14.0287 8.55 13.6V8.4C8.55 7.97128 8.77872 7.57513 9.15 7.36075C9.52128 7.14643 9.97872 7.14643 10.35 7.36075C10.7213 7.57513 10.95 7.9713 10.95 8.4V13.6ZM9.75 5.6C9.43177 5.6 9.1265 5.47357 8.9015 5.2485C8.67643 5.0235 8.55 4.71823 8.55 4.4C8.55 4.08177 8.67643 3.7765 8.9015 3.5515C9.1265 3.32643 9.43177 3.2 9.75 3.2C10.0682 3.2 10.3735 3.32643 10.5985 3.5515C10.8236 3.7765 10.95 4.08177 10.95 4.4C10.95 4.71823 10.8236 5.0235 10.5985 5.2485C10.3735 5.47357 10.0682 5.6 9.75 5.6Z",
    fill: "#076EB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.f8c2fbfe7b37994a06ede4c6c4dc7286.svg";
export { ForwardRef as ReactComponent };